import styled from 'styled-components';
import { layout } from 'src/components/base';

export const Image = styled.section`
  figure {
    img {
      display: block;
      margin: 0 auto;
      max-width: 100%;
      border-radius: 8px;
    }
    figcaption {
      text-align: left;
      margin-top: ${layout.measurements.spacing050};
    }
  }
`;
